export enum AuthStatus {
  Signed = 1,
  Logout = 2,
  Unauthorized = 3,
  Expired = 4
}
